import { useContext } from 'react';
import ConfigContext from '../config-provider/ConfigContext';
export default function useConfig() {
    return useContext(ConfigContext);
}
